/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Subject_TitleInputs */

const en_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Subject of the Contract`)
};

const de_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Vertragsgegenstand`)
};

const fr_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Objet du contrat`)
};

const es_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Objeto del contrato`)
};

const it_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Oggetto del contratto`)
};

const nl_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Onderwerp van de overeenkomst`)
};

const pl_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Przedmiot umowy`)
};

const fi_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Sopimuksen kohde`)
};

const da_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Aftalens genstand`)
};

const sv_agb_subject_title = /** @type {(inputs: Agb_Subject_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Avtalsföremål`)
};

/**
* | output |
* | --- |
* | "2. Subject of the Contract" |
*
* @param {Agb_Subject_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_subject_title = /** @type {((inputs?: Agb_Subject_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Subject_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_subject_title(inputs)
	if (locale === "fr") return fr_agb_subject_title(inputs)
	if (locale === "es") return es_agb_subject_title(inputs)
	if (locale === "it") return it_agb_subject_title(inputs)
	if (locale === "nl") return nl_agb_subject_title(inputs)
	if (locale === "pl") return pl_agb_subject_title(inputs)
	if (locale === "fi") return fi_agb_subject_title(inputs)
	if (locale === "da") return da_agb_subject_title(inputs)
	if (locale === "sv") return sv_agb_subject_title(inputs)
	return en_agb_subject_title(inputs)
});